import { motion } from "motion/react";
import { DotPattern } from "@/components/ui/dot-pattern";

export function FeaturesHero() {
  return (
    <section className="relative overflow-hidden pt-32 pb-16 sm:pt-40 sm:pb-20">
      <DotPattern
        width={20}
        height={20}
        cr={1}
        className="text-foreground/[0.15] [mask-image:radial-gradient(600px_circle_at_center,white,transparent)]"
      />

      <div className="relative mx-auto max-w-3xl px-6 text-center">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-brand mb-4 text-sm font-semibold tracking-wide uppercase"
        >
          FEATURES
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="font-display text-foreground text-4xl leading-[1.1] font-normal tracking-tight sm:text-5xl md:text-6xl"
        >
          Everything you need to{" "}
          <span className="text-brand italic">create</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="text-muted-foreground mx-auto mt-5 max-w-lg text-base leading-relaxed sm:text-lg"
        >
          A complete toolkit for building, running, and iterating on AI-powered
          content pipelines — no code required.
        </motion.p>
      </div>
    </section>
  );
}
